import { input, effect, Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'dynamic',
    changeDetection: ChangeDetectionStrategy.Eager,
    template: ''
})
export abstract class DynamicComponent {
    type = input<string>();
    model = input<any>();

    protected init: (model: any) => void = () => {};

    constructor() {
        effect(() => {
            const model = this.model();
            if (model) {
                this.init(model);
            }
        });
    }
}
